import React from 'react';

const TickIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66675 7.66667L4.84329 10.8295C4.93881 10.9246 5.09252 10.9268 5.19079 10.8346L15.6667 1"
      stroke="#171717"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default TickIcon;
